import { render, staticRenderFns } from "./CollectionLoansPage.vue?vue&type=template&id=a416cc48&lang=pug&"
import script from "./CollectionLoansPage.vue?vue&type=script&lang=js&"
export * from "./CollectionLoansPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports